module.exports = __webpack_public_path__ + "static/Gallery-10-95f1f8c712c4181214f08de5211e3dc0.jpg";